import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../hooks';
import { setDataflowColoring, selectedColoringSelector } from '../dataflow/colorSlice';
import { setTimingRange } from '../dataflow/rangeSlice';
import { selectedValuesSelector } from '../dataflow/selectionSlice';
import './Controls.css';
export function Controls() {
    const dispatch = useDispatch();
    const coloring = useAppSelector(selectedColoringSelector);
    const values = useAppSelector(selectedValuesSelector);
    const toggle = (eventSource) => dispatch(setDataflowColoring(eventSource.target.value));
    if (values) {
        const time = Object.entries(values).map((v) => {
            return v[1]['value'].time;
        });
        const max_value = Math.ceil(Math.max(...time) * 100) / 100;
        const min_value = Math.floor(Math.min(...time) * 100) / 100;
        return (React.createElement("div", { className: "controls-container" },
            React.createElement("form", { className: "control-container" },
                React.createElement("p", null, "Color graph by:"),
                React.createElement("input", { type: "radio", value: "type", name: "dataflow_color", onChange: toggle, checked: coloring === 'type' }),
                "Node Type",
                React.createElement("input", { type: "radio", value: "time", name: "dataflow_color", onChange: toggle, checked: coloring === 'time' }),
                "Time"),
            values !== null && coloring === 'time' && (React.createElement("div", { className: "control-container" },
                React.createElement("p", null, "Filter graph timings:"),
                React.createElement(Slider, { values: { min: min_value, max: max_value }, onChange: ({ min, max }) => dispatch(setTimingRange({ min, max })) })))));
    }
    return null;
}
const Slider = ({ values, onChange }) => {
    const { min, max } = values;
    const [minVal, setMinVal] = React.useState(min);
    const [maxVal, setMaxVal] = React.useState(max);
    React.useEffect(() => {
        setMinVal(min);
        setMaxVal(max);
    }, [values.min, values.max]);
    const minValRef = React.useRef(null);
    const maxValRef = React.useRef(null);
    const range = React.useRef(null);
    const getPercent = React.useCallback((value) => Math.round(((value - min) / (max - min)) * 100), [min, max]);
    React.useEffect(() => {
        if (maxValRef.current) {
            const minPercent = getPercent(minVal);
            const maxPercent = getPercent(+maxValRef.current.value);
            if (range.current) {
                range.current.style.left = `${minPercent}%`;
                range.current.style.width = `${maxPercent - minPercent}%`;
            }
        }
    }, [minVal, getPercent]);
    React.useEffect(() => {
        if (minValRef.current) {
            const minPercent = getPercent(+minValRef.current.value);
            const maxPercent = getPercent(maxVal);
            if (range.current) {
                range.current.style.width = `${maxPercent - minPercent}%`;
            }
        }
    }, [maxVal, getPercent]);
    React.useEffect(() => {
        onChange({ min: minVal, max: maxVal });
    }, [minVal, maxVal]);
    return (React.createElement("div", { className: "container" },
        React.createElement("input", { type: "range", min: min, max: max, step: 0.01, value: minVal, ref: minValRef, onChange: (event) => {
                const value = Math.min(+event.target.value, maxVal);
                setMinVal(value);
                event.target.value = value.toString();
            }, className: "thumb thumb--zindex-3" }),
        React.createElement("input", { type: "range", min: min, max: max, step: 0.01, value: maxVal, ref: maxValRef, onChange: (event) => {
                const value = Math.max(+event.target.value, minVal);
                setMaxVal(value);
                event.target.value = value.toString();
            }, className: "thumb thumb--zindex-4" }),
        React.createElement("div", { className: "slider" },
            React.createElement("div", { className: "slider__min-value" }, min),
            React.createElement("div", { className: "slider__max-value" }, max),
            React.createElement("div", { className: "slider__track" }),
            React.createElement("div", { ref: range, className: "slider__range" }),
            React.createElement("div", { className: "slider__left-value" }, minVal),
            React.createElement("div", { className: "slider__right-value" }, maxVal))));
};
